module.exports = __webpack_public_path__ + "_/assets/images/icons/icon-cycle-5feb6fe2f6b452b1c59fe2345d6a8d40.svg";